import { render, staticRenderFns } from "./buyMotor.vue?vue&type=template&id=23deb015&"
import script from "./buyMotor.vue?vue&type=script&lang=ts&"
export * from "./buyMotor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports